import { useState, useEffect } from 'react';
import { Box, Flex, Grid, Image} from "@chakra-ui/react";
import VaultEmptyState from './VaultEmptyState';
import DsrCardDisplay from '../dashboard/components/vault/DsrCardDisplay';

import PageLoader from '../global/components/helper-components/components/PageLoader';
import './styles/vault-display.scss'
import DsrGuestCardDisplay from '../dashboard/components/vault/DsrGuestCardDisplay';
import ProspectDsrCardDisplay from '../dashboard/components/vault/ProspectDsrCardDisplay';
import EmptyRoomIcon from '../vault/styles/images/received-rooms-invite.png';
import TemplateCardDisplay from '../dashboard/components/vault/TemplateCardDisplay';
import LaunchdeckButton from '../global/components/helper-components/components/LaunchdeckButton';
import ShortLogo from '../global/styles/images/launchdeck-short-logo-icon.png';
import JoinRequestCardDisplay from '../dashboard/components/vault/JoinRequestCardDisplay';
import LaunchdeckTooltip from '../global/components/helper-components/components/LaunchdeckTooltip';

export default function VaultDisplayDsrModule({ 
  displayedDsrs,
  isMobileView,
  vaultIsProcessing,
  foundDsrsTotal, 
  itemsPerPage,
  toggleFilter,
  currentPageNumber,
  requestCategory,
  chosenSortValue,
  isReceivedRoomsPage,
  isPdsrDisplayMode,
  onClickCreateDsr,
  handleChangeUserActionRequired,
  remainingAssets,
  onClickSubscriptionNudge,
  chosenStatusTab,
  chosenFilterValue,
  handleClearSearch,
  onClickHowToCreateTemplate,
  publishedDsrs,
  unpublishedDsrs,
  archivedDsrs,
  publishedProspectors,
  unpublishedProspectors
 }) {
   
  const [imageClassName, setImageClassName] = useState('image-loading__in-progress')
  const [totalPages, setTotalPages] = useState(1)
  
  const handlePageButtonClick = (pageNumber) => {
    let sortRequest= "default";
    
    switch (chosenSortValue) {
      case('Latest'): {
        sortRequest = "latest"
        break;
      }
      case('Room name (A - Z)'): {
        sortRequest = "a-to-z"
        break;
      }
      case('Room name (Z - A)'): {
        sortRequest = "z-to-a"
        break;
      }
      default: {
        break;
      }
    }

    toggleFilter(requestCategory, pageNumber, sortRequest)
  }

  useEffect(() => {
    if (foundDsrsTotal && itemsPerPage) {
      setTotalPages(Math.ceil(foundDsrsTotal/itemsPerPage))
    }
  }, [foundDsrsTotal, itemsPerPage])

  function handleImageLoaded() {
    setImageClassName("image-loading__completed");
  }

  const renderPaginationButtons = () => {
    const maxButtonsDisplayed = 5;
    let nextNumber = 0;
    let buttonTextArray = [];

    const lowerBound = (maxButtonsDisplayed > totalPages) ? totalPages : maxButtonsDisplayed;
    const includeTruncateButton = (maxButtonsDisplayed > totalPages) ? false : true;

    while (lowerBound > nextNumber) {
      buttonTextArray = [...buttonTextArray, nextNumber+1]
      nextNumber++;
    }

    if (Array.isArray(buttonTextArray)) {
      const renderedButtons = buttonTextArray?.map((element, index) => {
        const pageNumber = index + 1;
        return (
          <Box key={`page-button-${index}`} 
          className={currentPageNumber === pageNumber ? "chosen-page-button" : "unchosen-page-button"}
          onClick={()=>handlePageButtonClick(pageNumber)}>
            {element}
          </Box>
        )
      })

      return <Flex w='100%' justify='center' mt='1em'>
        <Flex>
        {(currentPageNumber > 1) &&
          <Box className="unchosen-page-button" onClick={()=>handlePageButtonClick(currentPageNumber-1)}> {`<`} </Box>
        }
          {renderedButtons}
         
          {(currentPageNumber < nextNumber) &&
          <>
            {includeTruncateButton && <Box>...</Box>}
            <Box className="unchosen-page-button" onClick={()=>handlePageButtonClick(currentPageNumber+1)}> {`>`} </Box>
          </>
          }
          </Flex>
     
        </Flex>;    
  }
}

  const renderDsrCards = () => {
    return (
      <Grid templateColumns={['repeat(1, 1fr)', 'repeat(2, 1fr)', 'repeat(2, 1fr)', 'repeat(3, 1fr)']} gap={12} w='100%'>
      {displayedDsrs.map((dsr, index) => {
        if (dsr.showNudgeCard === true) {
          return (
            <Box key={`dsr-card-nudge-${index}`} className='flip-in-hor-bottom'>
              {renderNudgeCard()}
            </Box>
          )
        } else {
          if (isReceivedRoomsPage) {
            if (chosenStatusTab === "join-requests") {
              return (
                <Box key={`dsr-card-${dsr.dsrId}`} className='flip-in-hor-bottom'>
                <JoinRequestCardDisplay 
                  dsrData={dsr}
                  handleChangeUserActionRequired={handleChangeUserActionRequired}
                  />
              </Box>
              )
            }
            return (
              <Box key={`dsr-card-${dsr.dsrId}`} className='flip-in-hor-bottom'>
                <DsrGuestCardDisplay dsrData={dsr} />
              </Box>
            )
          } else {
            return (
              <Box key={`dsr-card-${dsr.dsrId}`} className='flip-in-hor-bottom'>
                <DsrCardDisplay 
                  dsrData={dsr} 
                  handleChangeUserActionRequired={handleChangeUserActionRequired}
                  publishedDsrs={publishedDsrs}
                  unpublishedDsrs={unpublishedDsrs}
                  archivedDsrs={archivedDsrs}
                  chosenStatusTab={chosenStatusTab}
                  />
              </Box>
            )
          }
        
        }
      })}
    </Grid>
    )
  }

  const renderTemplateCards = () => {
    return (
      <Grid templateColumns={['repeat(1, 1fr)', 'repeat(2, 1fr)', 'repeat(2, 1fr)', 'repeat(3, 1fr)']} gap={12} w='100%'>
      {displayedDsrs.map((template, index) => {
       return (
          <Box key={`dsr-card-${template.dsrTemplateId}`} className='flip-in-hor-bottom'>
            <TemplateCardDisplay 
              templateData={template} 
              handleChangeUserActionRequired={handleChangeUserActionRequired}
              />
          </Box>
        )
      })}
    </Grid>
    ) 
  }

  const renderProspectDsrCards =() => {
    return (
      <Grid templateColumns={['repeat(1, 1fr)', 'repeat(2, 1fr)', 'repeat(2, 1fr)', 'repeat(3, 1fr)']} gap={12} w='100%'>
        {displayedDsrs.map((dsr, index) => {
           if (dsr.showNudgeCard === true) {
            return (
              <Box key={`dsr-card-nudge-${index}`} className='flip-in-hor-bottom'>
                {renderNudgeCard()}
              </Box>
            )
          } else return (
            <Box key={`dsr-card-${dsr.pDsrId}`} className='flip-in-hor-bottom'>
              <ProspectDsrCardDisplay 
                dsrData={dsr} 
                handleChangeUserActionRequired={handleChangeUserActionRequired}
                publishedProspectors={publishedProspectors}
                unpublishedProspectors={unpublishedProspectors}
                chosenStatusTab={chosenStatusTab}
              />
            </Box>
          )
        })}
      </Grid>
    )
  }

  const renderNudgeCard = () => {
    const displayedAssetName = isPdsrDisplayMode ? "Prospectors": "Rooms";
    const isPlural = (remainingAssets !== 1) ? true : false

    return (
      <Flex className="card-display" position='relative' cursor='default' h='100%' bgGradient="linear(to-r, #2D3748, #243b55)" justify='center' align='center' opacity='1.0'>
       {!isMobileView &&  <Box position='absolute' top='1em' left='1em'>
              <Image src={ShortLogo} className={imageClassName} onLoad={()=>setImageClassName('image-loading__completed')} boxSize="1.5em" objectFit="cover" alt="Launchdeck Short Logo" />
              </Box>
  }
      <Box w='100%'>
        <Box className="card-content-stack__column" cursor='default'>
          <Flex w='100%' color='white' direction='column' justify='center' align='center' gap={2} textAlign={['center', 'left']}>
            <Flex justify='center' w='100%' fontSize='0.95em'>{remainingAssets} {isPdsrDisplayMode ? `${isPlural ? 'Prospectors' : 'Prospector'}`: `${isPlural ? 'Rooms' :'Room'}`} remaining</Flex>
            
            {!remainingAssets && <Flex fontSize='0.7em'>You've reached the free limit 
              {!isMobileView && <span>
                <Box ml='1em'>
                <LaunchdeckTooltip
                  closeDelay={1000} 
                  w='300px'
                  placement='right-start'
                  color='white'
                  sx={{
                    border: "1px solid", // Dashed border
                    borderColor: "whiteAlpha.500", // Chakra color token
                    borderRadius: "0.5em", // Large border radius
                    padding:'0.5em'
                  }}
                  hoverMessage={`Everyone gets to publish up to 5 Rooms for free. For unlimited Rooms, upgrade this account`} />
                </Box>
              </span>}
            </Flex> 
  }
          
            <Box mt='1em'>
              <LaunchdeckButton bg='brand.500' color='white' px='2em' fontSize='0.8em' w={["100%", "auto"]} onClick={() => onClickSubscriptionNudge()} label={`Publish unlimited ${displayedAssetName}`} />
            </Box>

            {(remainingAssets > 0) && 
       
              <Flex mt='0.5em' fontSize='0.7em' textAlign='center' whiteSpace="pre"> 
                {`Everyone can publish up to 5 ${displayedAssetName} for free\n Upgrade to go unlimited`}
              </Flex>
         
              }
          </Flex>

         

        </Box>
      </Box>
    </Flex>
    )
  }
  
  if (vaultIsProcessing=== true || !displayedDsrs) {
    return <PageLoader /> 
  } else {

    if (displayedDsrs?.length === 0) {
      let displayType = "";
      
      switch (chosenStatusTab) {
        case("published"): 
        case("drafts"): {
          displayType = isPdsrDisplayMode ? "no-published-prospectors-vault" : "no-published-rooms-vault"
          break;
        }
        case("templates"): {
          if (chosenFilterValue === "Owned by me") {
            displayType = "no-templates-vault-after-filter"
          } else {
            displayType = "no-templates-vault"
          }
          break;
        }
        case("join-requests"): {
          displayType = "no-join-requests"
          break;
        }
        default: {
          break;
        }
      }
      return (
        <Flex w='100%' direction={['column', 'row', 'row', 'row']} justify='center' alignItems={['center', '']} flexWrap='wrap' px={['', '1em', '1em', '1em']} py='1em'>
          <VaultEmptyState 
          isMobileView={isMobileView}
          onClickCreateDsr={onClickCreateDsr}
          iconImage={EmptyRoomIcon}
          displayType={displayType}
          handleImageLoaded={()=> handleImageLoaded()} 
          imageClassName={imageClassName} 
          imageSize={'5em'}
          handleClearRoomsSearchResults={handleClearSearch}
          onClickHowToCreateTemplate={onClickHowToCreateTemplate}
          />
        </Flex>)
    }

   
    if (displayedDsrs?.length > 0) {
      if (chosenStatusTab ==="templates") {
        return (
          <>
            {renderTemplateCards()}
          </>
        )
      }

      return (
        <>
          {isPdsrDisplayMode ? renderProspectDsrCards() : renderDsrCards()}
          {(totalPages > 1) && renderPaginationButtons()}
        </>
        
      )
    } 
  }
}
